import { MediaData } from 'components/MediaViewer'
import { AppPreviewActions } from '.'
import { TextListGroupValue } from 'particles/TextInputs/TextList/Group'
import { InterpolationListProps } from '..'

export interface UpdatePurchaseStep1DataPayload {
    taskTitle?: string
    stepTitle?: string
    title?: string
    description?: string
    examplePhotos?: MediaData[]
    purchaseLocations?: TextListGroupValue[]
    itemsToReview?: string[]
}

interface UpdatePurchaseInterpolationListDataPayload {
    howToBuy: InterpolationListProps
}

export const updatePurchaseStep1Data = (payload: UpdatePurchaseStep1DataPayload) => ({
    payload,
    type: AppPreviewActions.UPDATE_PURCHASE_STEP1_DATA,
})

export const updatePurchaseInterpolationListData = (payload: UpdatePurchaseInterpolationListDataPayload) => ({
    payload,
    type: AppPreviewActions.UPDATE_PURCHASE_PLACEHOLDER_DATA,
})
